import styled from 'styled-components';
import { COLOR, RADIUS, SPACING } from '../../../constants/theme';

export const EstimateTag = styled.span`
  display: inline-block;
  position: relative;
  top: -1px;
  margin-left: ${SPACING.sm};
  padding: 2px 7px;
  border: 1px solid ${COLOR.primaryBorder};
  border-radius: ${RADIUS.pill};
  background: ${COLOR.primaryLight};
  color: ${COLOR.primary};
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  vertical-align: middle;
`;

export const EstimateNote = styled.div`
  margin-top: 18px;

  > div {
    margin-bottom: 0;
  }
`;
